// import axios from "axios";
// import {
//   GET_PDF_LIST_FAILURE,
//   GET_PDF_LIST_SUCCESS,
//   GET_PDF_METADATA_FAILURE,
//   GET_PDF_METADATA_SUCCESS,
//   GET_RESOURCE_FAILURE,
//   GET_RESOURCE_SUCCESS,
//   UPLOAD_FILE_FAILURE,
//   UPLOAD_FILE_SUCCESS,
// } from "./resource.actionTypes";
// import { DELETE_PDF_LIST, GET_PDF_LISTS, GET_PDF_META_DATA, GET_UPLOADED_RESOURCE, POST_UPLOAD_PDF_FILE } from "../../utils/api";

// export const uploadPdfResource = (data) => async (dispatch) => {
//   const formData = new FormData();
//   formData.append("file", data.file);
//   formData.append("subject", data.subject);
//   formData.append("chapter", data.chapter);
//   formData.append("concept", data.concept);
//    const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "multipart/form-data",
//   };

//   try {
//     const resp = await axios.post(POST_UPLOAD_PDF_FILE, formData, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: UPLOAD_FILE_SUCCESS,
//         payload: resp.data,
//       });
//       return {success: true, response: resp.data}
//     } else {
//       dispatch({
//         type: UPLOAD_FILE_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//       return {success: false}
//     }
//   } catch (error) {
//     dispatch({
//       type: UPLOAD_FILE_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//      return {success: false, message : error}
//   }
// };

// export const getResource = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     // "Content-Type": "multipart/form-data",
//   };
//   try {
//     const resp = await axios.get(GET_UPLOADED_RESOURCE, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: GET_RESOURCE_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: UPLOAD_FILE_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: GET_RESOURCE_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const getPdfData = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;

//    const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.get(GET_PDF_META_DATA, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: GET_PDF_METADATA_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: GET_PDF_METADATA_FAILURE,
//         payload: {
//           message: { data: resp.data },
//         },
//       });
//        return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: GET_PDF_METADATA_FAILURE,
//       payload: {
//          message: errorMsg ,
//       },
//     });
//      return { success: false, message: errorMsg };
//   }
// };

// export const getPdfList = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;

//    const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.get(GET_PDF_LISTS, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: GET_PDF_LIST_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: GET_PDF_LIST_FAILURE,
//         payload: {
//           message: { data: resp.data },
//         },
//       });
//        return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: GET_PDF_LIST_FAILURE,
//       payload: {
//          message: errorMsg ,
//       },
//     });
//      return { success: false, message: errorMsg };
//   }
// };

// export const deletePdfList = (id) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;

//    const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.delete(`${DELETE_PDF_LIST}/${id}`, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       return { success: true };
//     } else {
//        return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//      return { success: false, message: errorMsg };
//   }
// };

import { apiRequest } from "../../api/apiRequest";
import {
  GET_PDF_LIST_FAILURE,
  GET_PDF_LIST_SUCCESS,
  GET_PDF_METADATA_FAILURE,
  GET_PDF_METADATA_SUCCESS,
  GET_RESOURCE_FAILURE,
  GET_RESOURCE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_SUCCESS,
} from "./resource.actionTypes";
import {
  DELETE_PDF_LIST,
  GET_PDF_LISTS,
  GET_PDF_META_DATA,
  GET_UPLOADED_RESOURCE,
  POST_UPLOAD_PDF_FILE,
} from "../../utils/api";

export const uploadPdfResource = (data) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("subject", data.subject);
  formData.append("chapter", data.chapter);
  formData.append("concept", data.concept);

  // File uploads can legitimately take longer than the default 15s timeout,
  // and this is a non-idempotent POST so it correctly defaults to 0 retries
  // (don't want to accidentally create duplicate uploads on retry).
  const result = await apiRequest("post", POST_UPLOAD_PDF_FILE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });

  if (result.success) {
    dispatch({
      type: UPLOAD_FILE_SUCCESS,
      payload: result.data,
    });
    return { success: true, response: result.data };
  } else {
    dispatch({
      type: UPLOAD_FILE_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const getResource = () => async (dispatch) => {
  const result = await apiRequest("get", GET_UPLOADED_RESOURCE);

  if (result.success) {
    dispatch({
      type: GET_RESOURCE_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: GET_RESOURCE_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const getPdfData = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PDF_META_DATA);

  if (result.success) {
    dispatch({
      type: GET_PDF_METADATA_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  } else {
    dispatch({
      type: GET_PDF_METADATA_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const getPdfList = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PDF_LISTS);

  if (result.success) {
    dispatch({
      type: GET_PDF_LIST_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  } else {
    dispatch({
      type: GET_PDF_LIST_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const deletePdfList = (id) => async (dispatch) => {
  const result = await apiRequest("delete", `${DELETE_PDF_LIST}/${id}`);

  if (result.success) {
    return { success: true };
  } else {
    return { success: false, message: result.message };
  }
};